export function digitsOnly(s) { return String(s || '').replace(/\D/g, '') }

export function formatCpf(s) {
  const c = digitsOnly(s).slice(0, 11)
  if (c.length <= 3) return c
  if (c.length <= 6) return `${c.slice(0, 3)}.${c.slice(3)}`
  if (c.length <= 9) return `${c.slice(0, 3)}.${c.slice(3, 6)}.${c.slice(6)}`
  return `${c.slice(0, 3)}.${c.slice(3, 6)}.${c.slice(6, 9)}-${c.slice(9)}`
}

export function isValidCpf(cpf) {
  const c = digitsOnly(cpf)
  if (c.length !== 11) return false
  if (/^(\d)\1{10}$/.test(c)) return false
  let s = 0
  for (let i = 0; i < 9; i++) s += parseInt(c[i]) * (10 - i)
  let r = 11 - (s % 11); if (r >= 10) r = 0
  if (r !== parseInt(c[9])) return false
  s = 0
  for (let i = 0; i < 10; i++) s += parseInt(c[i]) * (11 - i)
  r = 11 - (s % 11); if (r >= 10) r = 0
  return r === parseInt(c[10])
}

export function formatPhone(s) {
  const c = digitsOnly(s).slice(0, 11)
  if (c.length <= 2) return c
  if (c.length <= 7) return `(${c.slice(0, 2)}) ${c.slice(2)}`
  if (c.length <= 10) return `(${c.slice(0, 2)}) ${c.slice(2, 6)}-${c.slice(6)}`
  return `(${c.slice(0, 2)}) ${c.slice(2, 7)}-${c.slice(7)}`
}
